import type { Activity, EventActivityDetails, Owner, QuoteOwner } from '@paintscout/api'
import startCase from 'lodash/startCase'
import type { OptionsDocument } from 'paintscout'
import { translateEventType } from '../../builder/events/translate-event-type'
import type { ActivityVariant } from '../getActivityVariant'

export default function getActivityTooltip(
  activity: Activity,
  activityOwner: Owner | QuoteOwner,
  variant: ActivityVariant,
  options: OptionsDocument
): string | null {
  const activityContact = activity.details?.contact
  const activityType = activity.details?.activityType
  const activityOwnerName =
    variant === 'customer'
      ? `${activityContact?.firstName ?? ''} ${activityContact?.lastName ?? ''}`.trim()
      : `${activityOwner?.firstName ?? ''} ${activityOwner?.lastName ?? ''}`.trim()

  if (!activityType || (variant !== 'customer' && !activityOwnerName) || (variant === 'customer' && !activityContact)) {
    return null
  }

  if (variant === 'customer') {
    return `Customer: ${activityOwnerName}`
  }

  const getMessage = (type: string) => {
    switch (type) {
      case 'message':
        return 'Message Sent by '
      case 'payment':
        return 'Payment Added by '
      case 'note':
        return 'Note Edited'
      case 'deal-stage-changed':
        return 'Estimator: '
      case 'event-assigned':
      case 'event-cancelled':
      case 'event-created': {
        const postFix =
          type === 'event-created' ? 'scheduled for ' : type === 'event-assigned' ? 'assigned to' : 'cancelled by'
        return `${(activity.details as EventActivityDetails)?.production ? 'Job' : translateEventType({ eventType: (activity.details as EventActivityDetails)?.eventType, options })} ${postFix} `
      }
      case 'event-progress-updated': {
        const isComplete = (activity.details as EventActivityDetails)?.progress === 100
        return isComplete ? 'Job marked complete by ' : 'Job progress updated by '
      }
      default:
        return `${startCase(type)} by`
    }
  }

  return `${getMessage(activityType)} ${activityOwnerName}`
}
